import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoFlvComponent } from './video-flv.component';

@NgModule({
    declarations: [
        VideoFlvComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        VideoFlvComponent
    ]
})
export class NcVideoFlvModule { }